import { PAYMENT_TYPES } from '@vend/business-components'

/**
 * For cash discounting; payment types which contribute towards the cash discount.
 */
export const CASH_DISCOUNT_PAYMENT_TYPES = [
  PAYMENT_TYPES.CASH,
  PAYMENT_TYPES.GIFT_CARD,
  PAYMENT_TYPES.LOYALTY,
  PAYMENT_TYPES.STORE_CREDIT,
]

/**
 * Payment types to hide on sale_summary and receipts
 */
export const HIDDEN_PAYMENT_TYPES = [PAYMENT_TYPES.CURRENCY_ADJUST]

/**
 * A list of all the KLARNA payment types
 */
export const KLARNA_PAYMENT_TYPES = [
  PAYMENT_TYPES.KLARNA_UK,
  PAYMENT_TYPES.KLARNA_AU,
  PAYMENT_TYPES.KLARNA_NZ,
  PAYMENT_TYPES.KLARNA_US,
]
